import { v4 as uuidv4 } from 'uuid'
import DateService, { FMT } from '../DateService'

const createItemTitle = (content, fechaInicio, fechaFinal) => {
  if (!fechaInicio || !fechaFinal) return null

  const start = DateService.toDayjs(fechaInicio).format(FMT.date)
  const end = DateService.toDayjs(fechaFinal).format(FMT.date)

  return `${content}: ${start} → ${end}`
}

export const createItems = (planificaciones) => {
  const items = []

  for (const planificacion of planificaciones) {
    const {
      ID_PLANIFICACION_MEDIO,
      ID_MEDIO,
      ID_INCENDIO,
      ID_INFRAESTRUCTURA,
      FECHA_ALARMADO_PLANIF,
      FECHA_EN_CAMINO_PLANIF,
      FECHA_EN_LUGAR_PLANIF,
      FECHA_FINALIZADO_PLANIF,
      FECHA_FIN_DESCANSO_PLANIF
    } = planificacion

    const group = ID_MEDIO
    const data = {
      ID_PLANIFICACION_MEDIO,
      ID_INCENDIO,
      ID_INFRAESTRUCTURA
    }

    if (FECHA_ALARMADO_PLANIF && FECHA_EN_CAMINO_PLANIF) {
      const content = 'Ida'
      items.push({
        id: uuidv4(),
        group,
        content,
        start: FECHA_ALARMADO_PLANIF,
        end: FECHA_EN_CAMINO_PLANIF,
        className: 'transito',
        title: createItemTitle(content, FECHA_ALARMADO_PLANIF, FECHA_EN_CAMINO_PLANIF),
        data
      })
    }

    if (FECHA_EN_CAMINO_PLANIF && FECHA_EN_LUGAR_PLANIF) {
      const content = 'Incendio'
      items.push({
        id: uuidv4(),
        group,
        content,
        start: FECHA_EN_CAMINO_PLANIF,
        end: FECHA_EN_LUGAR_PLANIF,
        className: 'incendio',
        title: createItemTitle(content, FECHA_EN_CAMINO_PLANIF, FECHA_EN_LUGAR_PLANIF),
        data
      })
    }

    if (FECHA_EN_LUGAR_PLANIF && FECHA_FINALIZADO_PLANIF) {
      const content = 'Vuelta'
      items.push({
        id: uuidv4(),
        group,
        content,
        start: FECHA_EN_LUGAR_PLANIF,
        end: FECHA_FINALIZADO_PLANIF,
        className: 'transito',
        title: createItemTitle(content, FECHA_EN_LUGAR_PLANIF, FECHA_FINALIZADO_PLANIF),
        data
      })
    }

    if (FECHA_FINALIZADO_PLANIF && FECHA_FIN_DESCANSO_PLANIF && FECHA_FIN_DESCANSO_PLANIF > FECHA_FINALIZADO_PLANIF) {
      const content = 'Descanso'
      items.push({
        id: uuidv4(),
        group,
        content,
        start: FECHA_FINALIZADO_PLANIF,
        end: FECHA_FIN_DESCANSO_PLANIF,
        className: 'descanso',
        title: createItemTitle(content, FECHA_FINALIZADO_PLANIF, FECHA_FIN_DESCANSO_PLANIF),
        data
      })
    }
  }

  return items
}
